import { erc20Abi, type Hex } from 'viem';
import { useReadContract } from 'wagmi';
import { L1 } from '@/modules/chain-constants';
import { SAN_ADDRESS } from '@/modules/swap';

// Wallet SAN balance (wei). `balance` is `undefined` while loading /
// disconnected; `refetch` re-reads after a balance-changing action (swap).
export function useSanBalance(address: Hex | undefined): {
  balance: bigint | undefined;
  refetch: () => void;
} {
  const { data, refetch } = useReadContract({
    abi: erc20Abi,
    address: SAN_ADDRESS,
    functionName: 'balanceOf',
    args: address != null ? [address] : undefined,
    chainId: L1.id,
    query: { enabled: address != null },
  });
  return {
    balance: data,
    refetch: () => {
      void refetch();
    },
  };
}
